import modheader from './../../assets/modheader.png';
import wordpress from './../../assets/wordpress.png';
import opencart from './../../assets/opencart.png';
import tilda from './../../assets/tilda.png';
import plusIcon from './../../assets/icons/plus.svg';

export const ModulesResources = {
    modheader, wordpress, opencart, tilda, plusIcon
}